/* unplugin-vue-components disabled */import script from "./StudentDetailsExpanded.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDetailsExpanded.vue?vue&type=script&setup=true&lang=js"

import "./StudentDetailsExpanded.vue?vue&type=style&index=0&id=fffa5264&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fffa5264"]])

export default __exports__